import { render } from "./DownloadStatus.vue?vue&type=template&id=3a2f1968"
import script from "./DownloadStatus.vue?vue&type=script&lang=js"
export * from "./DownloadStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__